export class Status {
  public numStatusId: number;
  public strStatus = '';
}

